import {defineStore} from 'pinia';
import {ModuleCurrency} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import currencyAPI from '@/apis/di/currencyAPI';
const currencyStore = new BaseDictionaryStore(currencyAPI);
export const useCurrencyStore = defineStore(ModuleCurrency, {
  state: () => ({
    ...currencyStore.state,
    _config: {
      key: 'currency_id',
      code: 'currency_code',
      name: 'currency_name',
      table: 'di_currency',
      quickFollow: 'active',
      moduleName: 'Tiền tệ',
      defaultSort: 'currency_code',
    },
    moduleName: 'currency',
  }),
  actions: {...currencyStore.action},
  getters: {
    ...currencyStore.getters,
  },
});
